// iter156 — Şık kategori vitrini kartları (AI-görsel destekli)
// iter159 — Skeleton fallback + WebP-first image loading
import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";
import ProductCard from "./ProductCard";
import { ProductCardSkeleton } from "./Skeletons";

// Fallback görsel havuzu (kategori adına göre eşleştirme)
const CAT_IMG_PATTERNS = {
  seramik: "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200&q=80",
  granit: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=1200&q=80",
  banyo: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&q=80",
  mutfak: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80",
  karo: "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200&q=80",
  parke: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=80",
  duvar: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=1200&q=80",
  dis: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80",
  cephe: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80",
};
const DEFAULT_CAT_IMG = "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200&q=80";

function pickImage(cat) {
  if (cat.image_url || cat.image) return cat.image_url || cat.image;
  const name = (cat.title || cat.name || "").toLowerCase();
  for (const key of Object.keys(CAT_IMG_PATTERNS)) {
    if (name.includes(key)) return CAT_IMG_PATTERNS[key];
  }
  return DEFAULT_CAT_IMG;
}

export default function AutoCategorySection({ section, brandPrimary, isFirst = false }) {
  const cat = { title: section.title, image_url: section.image_url, name: section.title };
  const bg = pickImage(cat);
  const items = section.items || [];

  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10 md:py-14" data-testid={`auto-section-${section.slug}`}>
      {/* Hero-benzeri kategori başlığı: sol tarafta görsel + overlay, sağda 4-6 ürün */}
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        {/* Görsel/Başlık banner */}
        <div className="col-span-12 lg:col-span-4 relative overflow-hidden rounded-3xl aspect-[4/3] lg:aspect-auto group">
          <img src={bg} alt={section.title}
               loading={isFirst ? "eager" : "lazy"}
               decoding="async"
               fetchpriority={isFirst ? "high" : "low"}
               width="800" height="600"
               className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"/>
          <div className="absolute inset-0 bg-gradient-to-tr from-zinc-950/85 via-zinc-900/40 to-transparent"/>
          <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end text-white">
            {section.personalized && (
              <span className="self-start inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-400/90 text-zinc-900 text-[10px] font-bold uppercase tracking-widest mb-2">
                Size Özel
              </span>
            )}
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/70 font-semibold mb-1">Koleksiyon</div>
            <h2 className="font-display font-bold text-3xl md:text-4xl leading-tight" data-testid={`section-title-${section.slug}`}>
              {section.title}
            </h2>
            <div className="text-sm text-white/70 mt-1.5">{section.count}+ ürün · Ücretsiz keşif</div>
            <Link to={`/kategori/${section.slug}`}
                  className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-zinc-900 text-xs font-semibold hover:bg-amber-300 transition-colors self-start">
              Tüm {section.title} <ArrowRight size={12}/>
            </Link>
          </div>
        </div>

        {/* Ürünler grid — items boşken skeleton */}
        <div className="col-span-12 lg:col-span-8">
          {items.length === 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
              {Array.from({length: 4}).map((_, i) => <ProductCardSkeleton key={i}/>)}
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
                {items.slice(0, 4).map(p => <ProductCard key={p.id} p={p}/>)}
              </div>
              {items.length > 4 && (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mt-3 md:mt-4">
                  {items.slice(4, 7).map(p => <ProductCard key={p.id} p={p}/>)}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
